export default "__VITE_ASSET__Xv3s4XPU__"